<template>
  <div class="animated fadeIn">
    <Forms
      ref="frmFase"
      :title="'CADASTRO DE FASE'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave"
    >
      <div class="form-group row">
        <div class="col-md-12">
          <label
            ><small
              v-if="form.nome.required"
              class="text-danger"
              >*</small
            >
            Fase:</label
          >
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o Nome da Fase'"
              v-model="form.nome.value"
              :size="form.nome.maxlength"
              :required="form.nome.required"
              :state="form.nome.state"
            ></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import 'vue-select/dist/vue-select.css'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import { advancedOnException } from '@/components/tools/Utils'

import FaseModel from '@/shared/models/configurations/fasemodel.js'
import FaseForms from './fase-form.js'
import FaseRepository from '@/shared/http/repositories/configurations/fase.js'

export default {
  name: 'FaseAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: FaseModel,
      form: FaseForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {},
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      loading.pop()
    },
    onCreate () {
      loading.push()
      FaseRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((e) => advancedOnException(e, this.$lang))
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      FaseRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((e) => advancedOnException(e, this.$lang))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/ajuizamento/fase/components/add/faseadd.vue